import { Injectable } from '@angular/core';
import { AppSettings } from '../../utils/app.settings';
import { HttpClient } from '@angular/common/http';
import { IConsuptionOptions } from '../../interfaces/consumption.interface';
import { IDetailAtrRespose } from '../../interfaces/atr.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GiService {
  constructor(
    private appSetting: AppSettings,
    private httpClient: HttpClient
  ) {}

  private transformFilters(filters: string | any[] | undefined): string {
    if (!filters) return '';

    // Si filters es un array, convertirlo a string
    const filtersStr = Array.isArray(filters) ? filters.join('&') : filters;

    // Dividir los filtros en partes
    const filterParts = filtersStr.split('&');

    // Transformar cliente=XXX a idMedidor=XXX
    const transformedParts = filterParts.map(part => {
      if (part.startsWith('cliente=')) {
        const value = part.split('=')[1];
        return `idMedidor=${value}`;
      }
      return part;
    });

    return transformedParts.join('&');
  }

  getGiData(payload: IConsuptionOptions): Observable<IDetailAtrRespose[]> {
    const transformedFilters = this.transformFilters(payload.filters);
    const url = `${this.appSetting.gi.urls.base}?fechaInicio=${
      payload.startDate
    }&fechaFin=${payload.endDate}${
      transformedFilters ? `&${transformedFilters}` : ''
    }`;
    return this.httpClient.get<IDetailAtrRespose[]>(url);
  }
}
